'use client'

import { FC, memo } from 'react'
import { Banner } from '@/root/ui/tuuleliinid'
import { EditCartCard } from '../EditCartCard'
import { ReservationWithModification } from '@/root/modules/shared/EditReservation/types'

interface CartWithBannersProps {
  currentReservation: ReservationWithModification
  originalReservation: ReservationWithModification
  toPayAmount: number
  toPayBannerText: string
  toRefundBannerText: string
  confirmBannerText: string
  hasSaved: boolean
  isRefundOffered: boolean
  hideFirstLeg?: boolean
  hideSecondLeg?: boolean
}

export const CartWithBanners: FC<CartWithBannersProps> = memo(({
  currentReservation,
  originalReservation,
  toPayAmount,
  toPayBannerText,
  toRefundBannerText,
  confirmBannerText,
  hasSaved,
  isRefundOffered,
  hideFirstLeg,
  hideSecondLeg,
}) => (
  <>
    <div className="rounded-2xl bg-white p-6">
      <EditCartCard reservation={currentReservation} originalReservation={originalReservation} isRefundOffered={isRefundOffered} hideFirstLeg={hideFirstLeg} hideSecondLeg={hideSecondLeg} />
    </div>
    {toPayAmount > 0 && <Banner variant="warning" body={toPayBannerText} />}
    {isRefundOffered && <Banner variant="warning" body={toRefundBannerText} />}
    {!isRefundOffered && toPayAmount === 0 && hasSaved && (
      <Banner variant="warning" body={confirmBannerText} />
    )}
  </>
))
